export default __webpack_public_path__ + "static/media/5year.8d9ba7f6.svg";